module.exports = __webpack_public_path__ + "img/40_38_048_780.67823659.jpg";